// React
import React, {Component} from "react";
import {connect} from "react-redux";
// Routing
import {withRouter} from "react-router-dom";
// Material
import {CircularProgress} from "@material-ui/core";
// Vendor
import {showNotify} from "vendor/application/disptach";
// Infrastructure
import {IntegrationsAPI} from "api/application/Integrations";
// Application
import {getVerneFullBody, returnElementFromArray} from "vendor/application";
import {VerneFields} from "./form";
import {addPendingPhrase, isVerneComplete, updateVerneData, updateVernePhrases} from "./utils";
// Translations
import {withTranslation} from "react-i18next";
// Components
import {Button} from "@components/Input";
// SVG
import {channelsSvg} from "assets";
import {arrowRightSvg} from "@assets";

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: getVerneFullBody(),
            set_key_words: "",
            set_entry_phrases: ""
        };
    }

    componentDidMount = () => {
        this.getIntegrations();
    };

    // only one verne integration per project
    getIntegrations = async () => {
        const {access, actualProject} = this.props.data;
        try {
            const obj = new IntegrationsAPI(actualProject.id, access, this.props);
            const integrations = await obj.get_integrations();
            var exist = returnElementFromArray("verne", integrations, "channel");
            if (exist) {
                this.return();
            }
        } catch (err) {
            this.props.dispatch(showNotify({message: err, severity: "error"}));
        }
    };

    updateElement = (e, type) => {
        this.setState({data: updateVerneData(this.state.data, e, type)});
    };

    handleKeyWords = (e, type, elementType, chipToDelete, i) => {
        const pending = `set_${elementType}`;
        const new_state = updateVernePhrases(this.state.data, this.state[pending], e, type, chipToDelete, i, elementType);
        if (new_state) {
            this.setState({data: new_state.data, [pending]: new_state.value});
        }
    };

    return = () => {
        const {history} = this.props;
        const {actualProject} = this.props.data;
        history.push(`/${actualProject.id}/integrations/verne`);
    };

    postIntegration = async (e) => {
        e.preventDefault();
        const {access, actualProject} = this.props.data;
        const {history} = this.props;
        let data = addPendingPhrase(this.state.data, this.state.set_entry_phrases, "entry_phrases");
        data = addPendingPhrase(data, this.state.set_key_words, "key_words");
        this.setState({data: data, set_key_words: "", set_entry_phrases: ""});

        try {
            const obj = new IntegrationsAPI(actualProject.id, access, this.props, data);
            let integration = await obj.post_integration();
            this.props.dispatch(showNotify({message: "integrations", type: "create", severity: "success"}));

            history.push(`/${actualProject.id}/integrations/verne/edit/${integration.id}`);
        } catch (err) {
            this.props.dispatch(showNotify({message: err, severity: "error"}));
        }
    };

    render() {
        const {data, set_key_words, set_entry_phrases} = this.state;
        const {t} = this.props;
        const {isSending} = this.props.data;
        return (
            data &&
                <div className={"cen_integrations"}>
                    <div className={"header"}>
                        <div className={"header_content"}>
                            <div onClick={() => this.return()} className={"header_action"}>
                                {arrowRightSvg()}
                            </div>
                            <div className={"header_image"}>
                                {channelsSvg("verne")}
                            </div>
                            <div className={"header_title"}>
                                <span className={"title"}>{t("integrations:channels.verne.title")}</span>
                                <span className={"description"}>{t("integrations:categories.business")}</span>
                            </div>
                        </div>
                        <div className={"header_actions"}>
                            {
                                isSending ? (
                                    <Button type={"primary"} disabled text={<CircularProgress size={21}/>}/>
                                ) : (
                                    <Button type={"primary"}
                                            text={t("integrations:create.action_button")}
                                            disabled={!isVerneComplete(data, set_entry_phrases, set_key_words)}
                                            onClick={(e) => this.postIntegration(e)}/>
                                )
                            }
                        </div>
                    </div>
                    <VerneFields
                        t={t}
                        data={data}
                        set_key_words={set_key_words}
                        set_entry_phrases={set_entry_phrases}
                        updateElement={this.updateElement}
                        handleKeyWords={this.handleKeyWords}
                    />
                </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        data: state
    };
};

const create = connect(
    mapStateToProps
)(Create);

export default withTranslation(["commons", "integrations", "common"])(withRouter(create));
